import type { SalesStage } from '../api';

/** Маршрут заказа Onviz: продажа → замер → состав → цех → выдача → закрытие. */
export const ONVIZ_JOURNEY_STEPS: Array<{
  stage: SalesStage;
  label: string;
  managerHint: string;
}> = [
  {
    stage: 'lead_received',
    label: 'Заявка',
    managerHint: 'Принять обращение, назначить задачу на первый контакт.',
  },
  {
    stage: 'negotiation',
    label: 'Сделка',
    managerHint: 'Конфигурация, условия, КП — без выезда на объект.',
  },
  {
    stage: 'invoice_sent',
    label: 'Счёт',
    managerHint: 'Счёт отправлен, ждём оплату.',
  },
  {
    stage: 'paid',
    label: 'Оплата',
    managerHint: 'Оплата есть — можно планировать замер.',
  },
  {
    stage: 'measurement',
    label: 'Замер',
    managerHint: 'Выезд инженера, слот с клиентом, адрес объекта.',
  },
  {
    stage: 'measurement_done',
    label: 'После замера',
    managerHint: 'Отчёт замера, спецификация по помещениям.',
  },
  {
    stage: 'compose',
    label: 'Состав',
    managerHint: 'Заполнить заказ в каталоге, согласовать позиции и смету.',
  },
  {
    stage: 'production',
    label: 'Производство',
    managerHint: 'Передано в цех — контроль сроков.',
  },
  {
    stage: 'ready_to_ship',
    label: 'Готов',
    managerHint: 'Изделие готово на складе.',
  },
  {
    stage: 'fulfillment',
    label: 'Выдача',
    managerHint: 'Монтаж, доставка или самовывоз — согласовать дату.',
  },
];

export const SALES_STAGE_GROUPS: Array<{
  id: string;
  title: string;
  subtitle: string;
  stages: SalesStage[];
}> = [
  {
    id: 'sell',
    title: 'Продажа',
    subtitle: 'До оплаты',
    stages: ['lead_received', 'negotiation', 'invoice_sent', 'paid'],
  },
  {
    id: 'measure',
    title: 'Замер',
    subtitle: 'Объект и отчёт',
    stages: ['measurement', 'measurement_done'],
  },
  {
    id: 'spec',
    title: 'Состав заказа',
    subtitle: 'Каталог и смета',
    stages: ['compose'],
  },
  {
    id: 'make',
    title: 'Изготовление',
    subtitle: 'Цех',
    stages: ['production', 'ready_to_ship'],
  },
  {
    id: 'finish',
    title: 'Выдача',
    subtitle: 'Монтаж / доставка / самовывоз',
    stages: ['fulfillment'],
  },
];

export function journeyIndex(stage: SalesStage): number {
  const i = ONVIZ_JOURNEY_STEPS.findIndex((s) => s.stage === stage);
  return i >= 0 ? i : 0;
}

export function journeyStep(stage: SalesStage) {
  return ONVIZ_JOURNEY_STEPS.find((s) => s.stage === stage) ?? ONVIZ_JOURNEY_STEPS[0];
}

/** Операционный статус для клиента (как во вкладке «Заказы»). */
export const OPS_STATUS_FLOW = [
  'pending',
  'confirmed',
  'in_production',
  'ready',
  'delivered',
] as const;

export type OpsStatus = (typeof OPS_STATUS_FLOW)[number];

export const OPS_STATUS_HINTS: Record<string, string> = {
  pending: 'Заказ создан, менеджер проверяет детали.',
  confirmed: 'Заказ принят в работу (после замера/состава).',
  in_production: 'Изготовление на производстве.',
  ready: 'Готов к монтажу, доставке или самовывозу.',
  delivered: 'Заказ закрыт — выдан клиенту.',
  cancelled: 'Заказ отменён.',
};
